import { observable, action } from 'mobx';
import { profileStore, commonStore } from '.';
import { api } from '../services';

class AuthStore {
  @observable
  inProgress = false;
  @observable
  errors = undefined;
  @observable
  justLoggedIn = false;

  @observable
  values = {
    username: '',
    email: '',
    password: ''
  };

  @action
  setUsername(username) {
    this.values.username = username;
  }

  @action
  setEmail(email) {
    this.values.email = email;
  }

  @action
  setPassword(password) {
    this.values.password = password;
  }

  @action
  reset() {
    this.values.username = '';
    this.values.email = '';
    this.values.password = '';
  }

  @action
  login() {
    this.inProgress = true;
    this.errors = undefined;
    return api({ action: 'login' }, this.values.email, this.values.password)
      .then(token => commonStore.setToken(token))
      .then(() => profileStore.pullUser())
      .catch(
        action(err => {
          this.errors = err.response && err.response.body && err.response.body.errors;
          throw err;
        })
      )
      .then(
        action(() => {
          this.inProgress = false;
          this.justLoggedIn = true;
        })
      );
  }

  @action
  refreshToken(refreshToken) {
    this.inProgress = true;
    this.errors = undefined;
    return api({ action: 'refresh token' }, refreshToken)
      .then(token => {
        console.log(token);
        commonStore.setToken(token);
      })
      .catch(
        action(err => {
          this.errors = err.response && err.response.body && err.response.body.errors;
          throw err;
        })
      )
      .then(token => {
        this.inProgress = false;
      });
  }

  @action
  setJustLoggedIn(trueOrFalse) {
    this.justLoggedIn = trueOrFalse;
  }

  @action
  logout() {
    commonStore.setToken(undefined);
    profileStore.forgetUser();
    return Promise.resolve();
  }
}

export default new AuthStore();



// WEBPACK FOOTER //
// ./src/stores/authStore.js